import requests from "../util";

const URL = "user-gateway";

const userGatewayApi = {
    findByUserId: (userId: string) =>
        requests.get(`${URL}?userId=${userId}`),
    getOrCreateMine: () =>
        requests.get(`${URL}/me`),
};

export default userGatewayApi;
